"use client";

import { FC } from "react";

interface IndicesActionsProps {
  onOptionChainClick: () => void;
  onChartClick: () => void;
  optionChainLabel?: string;
  chartsLabel?: string;
}

export const IndicesActions: FC<IndicesActionsProps> = ({
  onOptionChainClick,
  onChartClick,
  optionChainLabel,
  chartsLabel,
}) => {
  const optionChainText = optionChainLabel ?? "OPTION CHAIN";
  const chartsText = chartsLabel ?? "CHARTS";

  return (
    <div className="flex items-center gap-[22px] pt-[12px]">
      <div className="flex flex-1 items-center justify-center px-[11.5px]">
        <button
          onClick={onOptionChainClick}
          className="text-center text-[14px] font-medium text-[#FF6700] py-[11.5px]"
        >
          {optionChainText}
        </button>
      </div>
      <div className="h-[24px] w-px bg-[#cccccc]" />
      <div className="flex flex-1 items-center justify-center px-[11.5px]">
        <button
          onClick={onChartClick}
          className="text-center text-[14px] font-medium text-[#FF6700] py-[11.5px]"
        >
          {chartsText}
        </button>
      </div>
    </div>
  );
};

